import {Injectable} from '@angular/core';
import {Item} from '@catmodules/widgets/breadcrumb/types';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class BreadcrumbService {
  private breadcrumbs: Item[] = [];
  private rootItems: Item[] = [];
  private source = new BehaviorSubject<Item[]>(this.breadcrumbs);

  private cachedItems: Item[];

  current$ = this.source.asObservable();

  setRoot(items: Item[], preserve = false) {
    this.rootItems = items;
    this.update(preserve ? this.cachedItems : []);
  }

  update(items: Item[]) {
    this.cachedItems = items;
    this.breadcrumbs = [...this.rootItems, ...items];
    this.source.next(this.breadcrumbs);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/breadcrumb/services/breadcrumb.service.ts